export const gettersTypes = {
  report360CompareScoreScale: '[reports] report 360 compare score scale',
};

const getters = {
  [gettersTypes.report360CompareScoreScale]: (state) => {
    return state.report360Compare?.score_scale || {};
  },
};

export default getters;
